// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.fermentation_alert_limit_mode_enum */
var FermentationAlertLimitModeEnum;
(function (FermentationAlertLimitModeEnum) {
    FermentationAlertLimitModeEnum["ABSOLUTE"] = "ABSOLUTE";
    FermentationAlertLimitModeEnum["DEVIATION"] = "DEVIATION";
})(FermentationAlertLimitModeEnum || (FermentationAlertLimitModeEnum = {}));
;
export default FermentationAlertLimitModeEnum;
/** Zod schema for fermentation_alert_limit_mode_enum */
export const fermentationAlertLimitModeEnum = z.nativeEnum(FermentationAlertLimitModeEnum);
//# sourceMappingURL=FermentationAlertLimitModeEnum.js.map